'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _events = require('dom-helpers/events');

var _events2 = _interopRequireDefault(_events);

var _ownerDocument = require('dom-helpers/ownerDocument');

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _inDOM = require('dom-helpers/util/inDOM');

var _inDOM2 = _interopRequireDefault(_inDOM);

var _scrollbarSize = require('dom-helpers/util/scrollbarSize');

var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);

var _pick = require('lodash-compat/object/pick');

var _pick2 = _interopRequireDefault(_pick);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Modal = require('react-overlays/lib/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _isOverflowing = require('react-overlays/lib/utils/isOverflowing');

var _isOverflowing2 = _interopRequireDefault(_isOverflowing);

var _deprecated = require('react-prop-types/lib/deprecated');

var _deprecated2 = _interopRequireDefault(_deprecated);

var _elementType = require('react-prop-types/lib/elementType');

var _elementType2 = _interopRequireDefault(_elementType);

var _styleMaps = require('../utils/styleMaps');

var _bootstrapUtils = require('../utils/bootstrapUtils');

var _Fade = require('../Fade');

var _Fade2 = _interopRequireDefault(_Fade);

var _ModalDialog = require('./ModalDialog');

var _ModalDialog2 = _interopRequireDefault(_ModalDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/prop-types */
var Modal = function (_React$Component) {
  _inherits(Modal, _React$Component);

  function Modal() {
    _classCallCheck(this, Modal);

    var _this = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this));

    _this.state = {
      modalStyles: {}
    };
    _this._getStyles = _this._getStyles.bind(_this);
    _this._onShow = _this._onShow.bind(_this);
    _this._onHide = _this._onHide.bind(_this);
    _this.handleDialogClick = _this.handleDialogClick.bind(_this);
    _this.handleWindowResize = _this.handleWindowResize.bind(_this);
    return _this;
  }

  _createClass(Modal, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        $bs_onModalHide: this.props.onHide
      };
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _events2.default.off(window, 'resize', this.handleWindowResize);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          children = _props.children,
          dialogClassName = _props.dialogClassName,
          animation = _props.animation,
          style = _props.style,
          props = _objectWithoutProperties(_props, ['className', 'children', 'dialogClassName', 'animation', 'style']);

      var modalStyles = this.state.modalStyles;


      if (style) {
        modalStyles = _extends({}, modalStyles, style);
      }

      var inClass = { in: props.show && !animation };
      var Dialog = props.dialogComponent || props.dialogComponentClass;

      var parentProps = (0, _pick2.default)(props, Object.keys(_Modal2.default.propTypes).concat(['onExit', 'onExiting', 'onEnter', 'onEntered']) // the rest are fired in _onHide() and _onShow()
      );

      var modal = _react2.default.createElement(
        Dialog,
        _extends({
          key: 'modal',
          ref: function ref(_ref) {
            return _this2._modal = _ref;
          }
        }, props, {
          style: modalStyles,
          className: (0, _classnames2.default)(className, inClass),
          dialogClassName: dialogClassName,
          onClick: props.backdrop === true ? this.handleDialogClick : null
        }),
        this.props.children
      );

      return _react2.default.createElement(
        _Modal2.default,
        _extends({}, parentProps, {
          show: props.show,
          ref: function ref(_ref2) {
            _this2._wrapper = _ref2 && _ref2.refs.modal;
            _this2._backdrop = _ref2 && _ref2.refs.backdrop;
          },
          onEntering: this._onShow,
          onExited: this._onHide,
          backdropClassName: (0, _classnames2.default)((0, _bootstrapUtils.prefix)(props, 'backdrop'), inClass),
          containerClassName: (0, _bootstrapUtils.prefix)(props, 'open'),
          transition: animation ? _Fade2.default : undefined,
          dialogTransitionTimeout: Modal.TRANSITION_DURATION,
          backdropTransitionTimeout: Modal.BACKDROP_TRANSITION_DURATION
        }),
        modal
      );
    }
  }, {
    key: '_onShow',
    value: function _onShow() {
      _events2.default.on(window, 'resize', this.handleWindowResize);

      this.setState(this._getStyles());

      if (this.props.onEntering) {
        var _props2;

        (_props2 = this.props).onEntering.apply(_props2, arguments);
      }
    }
  }, {
    key: '_onHide',
    value: function _onHide() {
      _events2.default.off(window, 'resize', this.handleWindowResize);

      if (this.props.onExited) {
        var _props3;

        (_props3 = this.props).onExited.apply(_props3, arguments);
      }
    }
  }, {
    key: 'handleDialogClick',
    value: function handleDialogClick(e) {
      if (e.target !== e.currentTarget) {
        return;
      }

      this.props.onHide();
    }
  }, {
    key: 'handleWindowResize',
    value: function handleWindowResize() {
      this.setState(this._getStyles());
    }
  }, {
    key: '_getStyles',
    value: function _getStyles() {
      if (!_inDOM2.default) {
        return {};
      }

      var node = _reactDom2.default.findDOMNode(this._modal);
      var doc = (0, _ownerDocument2.default)(node);

      var scrollHt = node.scrollHeight;
      var bodyIsOverflowing = (0, _isOverflowing2.default)(_reactDom2.default.findDOMNode(this.props.container || doc.body));
      var modalIsOverflowing = scrollHt > doc.documentElement.clientHeight;

      return {
        modalStyles: {
          paddingRight: bodyIsOverflowing && !modalIsOverflowing ? (0, _scrollbarSize2.default)() : function () {
            return 0;
          },
          paddingLeft: !bodyIsOverflowing && modalIsOverflowing ? (0, _scrollbarSize2.default)() : function () {
            return 0;
          }
        }
      };
    }
  }]);

  return Modal;
}(_react2.default.Component);

Modal.defaultProps = _extends({}, _Modal2.default.defaultProps, {
  bsClass: 'modal',
  animation: true,
  dialogComponentClass: _ModalDialog2.default
});

Modal.propTypes = _extends({}, _Modal2.default.propTypes, _ModalDialog2.default.propTypes, {

  /**
   * Include a backdrop component. Specify 'static' for a backdrop that doesn't trigger an "onHide" when clicked.
   */
  backdrop: _propTypes2.default.oneOf(['static', true, false]),

  /**
   * Close the modal when escape key is pressed
   */
  keyboard: _propTypes2.default.bool,

  /**
   * Open and close the Modal with a slide and fade animation.
   */
  animation: _propTypes2.default.bool,

  /**
   * A Component type that provides the modal content Markup. This is a useful prop when you want to use your own
   * styles and markup to create a custom modal component.
   */
  dialogComponentClass: _elementType2.default,

  /**
   * @private
   */
  dialogComponent: (0, _deprecated2.default)(_elementType2.default, 'Use `dialogComponentClass`.'),

  /**
   * When `true` The modal will automatically shift focus to itself when it opens, and replace it to the last focused element when it closes.
   * Generally this should never be set to false as it makes the Modal less accessible to assistive technologies, like screen-readers.
   */
  autoFocus: _propTypes2.default.bool,

  /**
   * When `true` The modal will prevent focus from leaving the Modal while open.
   * Consider leaving the default value here, as it is necessary to make the Modal work well with assistive technologies,
   * such as screen readers.
   */
  enforceFocus: _propTypes2.default.bool,

  /**
   * Hide this from automatic props documentation generation.
   * @private
   */
  bsStyle: _propTypes2.default.string,

  /**
   * When `true` The modal will show itself.
   */
  show: _propTypes2.default.bool,

  /**
   * A callback fired when the header closeButton or non-static backdrop is
   * clicked. Required if either are specified.
   */
  onHide: _propTypes2.default.func,

  /**
   * Callback fired before the Modal transitions in
   */
  onEnter: _propTypes2.default.func,

  /**
   * Callback fired as the Modal begins to transition in
   */
  onEntering: _propTypes2.default.func,

  /**
   * Callback fired after the Modal finishes transitioning in
   */
  onEntered: _propTypes2.default.func,

  /**
   * Callback fired right before the Modal transitions out
   */
  onExit: _propTypes2.default.func,

  /**
   * Callback fired as the Modal begins to transition out
   */
  onExiting: _propTypes2.default.func,

  /**
   * Callback fired after the Modal finishes transitioning out
   */
  onExited: _propTypes2.default.func
});

Modal.childContextTypes = {
  '$bs_onModalHide': _propTypes2.default.func
};

Modal.Dialog = _ModalDialog2.default;

Modal.TRANSITION_DURATION = 300;
Modal.BACKDROP_TRANSITION_DURATION = 150;

exports.default = Modal;